<template>
  <div>
    <v-lp-tool-bar/>
    <v-img
      :src="mainImage"
      gradient="to top right, rgba(0,0,0,.33), rgba(0,0,0,.7)"
      :height="500"
    >
      <v-container
        fill-height
        class="main--text"
      >
        <v-row
          justify=end
          align=center
        >
          <v-col
            cols=12
            md=6
          >
            <h3
              class="white--text"
            >自宅で始める<br>プログラミング学習</h3>
            <br>
            <h1
              :class="headingStyle"
            >
              無料体験<br>受付中
            </h1>
          </v-col>
        </v-row>
      </v-container>
    </v-img>
    <v-sheet>
      <v-container
        class=main--text
        fluid>
        <v-row
          justify=center>
          <v-col
            cols=auto>
            <h1>子どものプログラミング教室って、どう選べば良いの…？</h1>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols=12
            sm=6>
            <v-img
              :src="introImage"
              :aspect_ratio="9/16"
              height=400>
            </v-img>
          </v-col>
          <v-col
            cols=12
            sm=6>
              <v-row>
                <ul class="trouble--list">
                  <li>近くに良さそうな教室がなくて…</li>
                  <li>本当に将来役に立つの…？</li>
                  <li>ちゃんと身につくか不安…</li>
                  <li>送り迎えが大変じゃ…</li>
                </ul>
              </v-row>
              <v-row
                justify=center>
                <v-col
                  cols=auto
                  >
                  <h1 class="emphasis--phrase">Prosenseに</h1>
                </v-col>
              </v-row>
              <v-row
                justify=center
                >
                <v-col
                  cols=auto
                  class="no--vertical--paddings">
                  <h1 class="emphasis--phrase">お任せください！</h1>
                </v-col>
              </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-sheet>
    <v-to-contact-icon/>
    <v-section-bar
      message="身につくチカラ"/>
    <v-container
      fluid
      class=main--text>
      <v-row
        justify=center>
        <v-col
          cols=12
          md=8>
          <v-what-to-learn-card/>
        </v-col>
      </v-row>
    </v-container>
    <v-container
      class="main--text">
      <v-to-contact-icon/>
    </v-container>
    <v-section-bar
      message="Prosenseの強み"/>
    <v-container
      class="main--text"
      fluid>
      <v-row>
        <v-col
          cols=12
          md=6>
          <v-container
            fluid>
            <v-row
              justify=center>
              <v-col
                cols=auto>
                <h2 class="emphasis--phrase">ブラウザで簡単にスタート</h2>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols=12>
                <v-img
                  :src="editorImage"></v-img>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
        <v-col
          cols=12
          md=6>
          <v-container
            fluid>
            <v-row
              justify=center>
              <v-col
                cols=auto>
                <h2 class="emphasis--phrase">一対一の個別指導</h2>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols=12>
                <v-img
                  :src="videoImage"></v-img>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
    </v-container>
    <v-strong-point-cards/>
    <v-to-contact-icon/>
    <v-section-bar
      message="品質を支えるAI技術"/>
      <v-container
        class="main--text"
        fluid>
        <v-row
          justify=center>
          <v-col
            cols=12
            md=6>
            <v-card>
              <v-img
                :src="aiImage"></v-img>
              <v-container
                fluid>
                <v-row>
                  <v-col
                    cols=12>
                    Prosenseでは、サービスの品質をより高めるため、最新のAI技術を活用しています。
                  </v-col>
                  <v-col
                    cols=12>
                    授業中の生徒の表情を解析し、授業の満足度を可視化。解析したデータを元に、講師間のフィードバックを行っています。
                  </v-col>
                  <v-col
                    cols=12>
                    「より楽しく、わかりやすく、満足度の高い授業を」<br>
                    Prosense講師陣は、皆この想いを共有し、ともに切磋琢磨しています。
                  </v-col>
                  <v-col
                    cols=12
                    class="caption">
                    解析対象となる情報は、サービス向上を目的として弊社内でのみ利用するものであり、第三者機関への提供、公共の場への発信等は一切いたしません。
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    <v-section-bar
      message="講師紹介"/>
    <v-container
      fluid>
      <v-row
        justify=center
        >
        <v-col
          cols=12
          md=10>
          <v-teacher-profile-carousel/>
        </v-col>
      </v-row>
    </v-container>
    <v-to-contact-icon/>
    <v-section-bar
      message="体験授業までの流れ"/>
    <v-sheet
      class=main--text>
      <v-container
        fluid>
        <v-row
          justify=center>
          <v-col
            cols=12
            md=8>
            <v-timeline
              :dense="$vuetify.breakpoint.smAndDown">
              <v-timeline-item
                icon="fab fa-line">
                <v-card>
                  <v-container
                    fluid>
                    <v-row
                      justify=center
                      no-gutters>
                      <v-col
                        cols=auto>
                        <h2>公式LINEを友だち登録</h2>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card>
              </v-timeline-item>
              <v-timeline-item
                icon="fa-calendar-alt">
                <v-card>
                  <v-container
                    fluid>
                    <v-row
                      no-gutters
                      justify=center>
                      <v-col
                        cols=auto>
                        <h2>担当講師と日程を調整</h2>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card>
              </v-timeline-item>
              <v-timeline-item
                icon="fa-chalkboard-teacher">
                <v-card>
                  <v-container
                    fluid>
                    <v-row
                      no-gutters
                      justify=center>
                      <v-col
                        cols=auto>
                        <h2>体験授業を受講！</h2>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card>
              </v-timeline-item>
            </v-timeline>
          </v-col>
        </v-row>
        <v-row
          justify=center>
          <v-col
            cols=12
            md=8>
            <v-stepper
              vertical
              alt-labels
              non-liner
              >
              <v-row
                justify=center>
                <v-col
                  cols=auto>
                  <h2>カリキュラム</h2>
                </v-col>
              </v-row>
              <v-stepper-step
                complete
                step=1>
                自己紹介＆プログラミングとは
                <small>所要時間：約10分</small>
              </v-stepper-step>
              <v-stepper-step
                complete
                step=2>
                プログラミングレッスン
                <small>所要時間：約30分</small>
              </v-stepper-step>
              <v-stepper-step
                complete
                step=3>
                振り返り＆保護者様向けご説明
                <small>所要時間：約20分</small>
              </v-stepper-step>
            </v-stepper>
          </v-col>
        </v-row>
        <v-row
          justify=center>
          <v-col
            cols=12
            md=8>
            <v-img :src="trialImage"></v-img>
          </v-col>
        </v-row>
      </v-container>
    </v-sheet>
    <v-to-contact-icon/>
    <v-section-bar
      message="保護者の方からの声"/>
    <v-sheet
      class="main--text">
      <v-container
        fluid>
        <v-row
          justify=center>
          <v-col
            cols=12
            sm=10
            md=8>
            <v-users-voices/>
          </v-col>
        </v-row>
      </v-container>
    </v-sheet>
    <v-to-contact-icon/>
    <v-section-bar
      message="よくあるご質問"/>
      <v-q-and-a-cards/>
    <v-to-contact-icon/>
    <v-section-bar
      message="LINE限定特典"/>
      <v-container
        class=main--text
        fluid>
        <v-row
          justify=center>
          <v-col
            cols=12
            md=6>
            <v-line-benefit-card/>
          </v-col>
        </v-row>
      </v-container>
      <v-to-contact-icon/>
    <v-section-bar
      message="サービス保証"/>
      <v-container
        class=main--text
        fluid>
        <v-row
          justify=center>
          <v-col
            cols=12
            md=6>
            <v-card>
              <v-img
                :src="motherAndDaughterImage"/>
              <v-container
                fluid>
                <v-row
                  justify=center>
                  <v-col
                    cols=auto>
                    <h3>受講開始から１ヶ月間について</h3>
                  </v-col>
                </v-row>
                <v-row
                  justify=center>
                  <v-col
                    cols=auto>
                    <h3>授業内容にご満足いただけなかった場合</h3>
                  </v-col>
                </v-row>
                <v-row
                  justify=center>
                  <v-col
                    cols=auto
                    class="red--text">
                    <h2>授業料を全額返金します</h2>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
      <v-to-contact-icon/>
    <v-lp-footer/>
  </div>
</template>

<script>
import MainImage from '@/assets/img/main_image.jpg'
import IntroImage from '@/assets/img/introduction_trouble.jpg'
import TrialImage from '@/assets/img/trial.jpg'
import EditorImage from '@/assets/img/editor.jpg'
import VideoImage from '@/assets/img/video.jpg'
import AIImage from '@/assets/img/ai_img.jpg'
import MotherAndDaughterImage from '@/assets/img/mother_and_daughter.jpg'
import VLpToolBar from '@/components/organisms/lp/VLpToolBar.vue'
import VSectionBar from '@/components/molecules/VSectionBar.vue'
import VPortalFooter from '@/components/organisms/portal/VPortalFooter.vue'
import VLpFooter from '@/components/organisms/lp/VLpFooter.vue'
import VToContactIcon from '@/components/organisms/portal/VToContactIcon.vue'
import VWhatToLearnCard from '@/components/organisms/lp/VWhatToLearnCard.vue'
import VUsersVoices from '@/components/organisms/lp/VUsersVoices.vue'
import VQAndACards from '@/components/organisms/lp/VQAndACards.vue'
import VStrongPointCards from '@/components/organisms/lp/VStrongPointCards.vue'
import VTeacherProfileCarousel from '@/components/organisms/lp/VTeacherProfileCarousel.vue'
import VLineBenefitCard from '@/components/organisms/lp/VLineBenefitCard.vue'

import { app } from '@/core/firebase'

export default {
  components: {
    VLpToolBar,
    VPortalFooter,
    VLpFooter,
    VSectionBar,
    VToContactIcon,
    VWhatToLearnCard,
    VUsersVoices,
    VQAndACards,
    VStrongPointCards,
    VTeacherProfileCarousel,
    VLineBenefitCard
  },
  data: () => {
    return {
      storage: null,
      mainImage: MainImage,
      introImage: IntroImage,
      trialImage: TrialImage,
      editorImage: EditorImage,
      videoImage: VideoImage,
      aiImage: AIImage,
      motherAndDaughterImage: MotherAndDaughterImage,
    }
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown
    },
    headingStyle () {
      return (this.isMobile) ? 'heading-text-mobile' : 'heading-text'
    }
  }
}
</script>

<style scoped>
.heading-text {
  text-shadow: 0 2px 4px rgba(41,48,59,.55);
  font-weight: 600;
  color: white;
  font-size:5.0rem;
  letter-spacing:5px;
}

.heading-text-mobile {
  text-shadow: 0 2px 4px rgba(41,48,59,.55);
  font-weight: 600;
  color: white;
  font-size:3.5rem;
  letter-spacing:3px;
}

.no--vertical--paddings {
  padding: 0px 12px;
}

.trouble--list li {
  margin: 0px 0px 10px 10px;
  font-weight: bold;
  font-size: 1.4rem;
  color: brown
}

.emphasis--phrase {
  background: linear-gradient(transparent 60%, #ffff66 60%)
}


</style>

